import { HeatmapLayer as L7HeatmapLayer } from '@antv/l7';
import { CoreLayer } from '../../core/core-layer';
/**
 * 热力图层
 * 对应 L7 的 HeatmapLayer
 **/
export class HeatmapLayer extends CoreLayer {
    constructor() {
        super(...arguments);
        this.type = 'heatmapLayer';
    }
    /**
     * 创建图层
     */
    createLayer() {
        const config = this.getLayerConfig();
        const layer = new L7HeatmapLayer(config);
        return layer;
    }
}
//# sourceMappingURL=index.js.map